const FOCUS_RESTORE_WINDOW_MS = 400

type PatchableElement = HTMLElement & { __focusScrollPatched?: boolean }

const suppressFocusScroll = (el: HTMLElement) => {
  const target = el as PatchableElement
  if (target.__focusScrollPatched) return
  target.__focusScrollPatched = true

  const original = target.focus.bind(target)
  target.focus = (options?: FocusOptions) => original({ ...options, preventScroll: true })

  setTimeout(() => {
    delete (target as Partial<PatchableElement>).focus
    delete target.__focusScrollPatched
  }, FOCUS_RESTORE_WINDOW_MS)
}

export const closeFloatingControlsOnScroll = () => {
  const activeElement = document.activeElement as HTMLElement | null

  if (activeElement?.classList.contains('MuiAutocomplete-input')) {
    activeElement.blur()
  }

  const openPickerPopper = document.querySelector('.MuiPickersPopper-root')
  if (!openPickerPopper) return

  document.querySelectorAll<HTMLInputElement>('[data-testid="date-time-picker"]').forEach(input => {
    suppressFocusScroll(input)
  })

  document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }))
}
